import React from 'react';

import SignIn from '@Components/login/signIn';

const SignInPage = props => (
  <SignIn {...props} />
);

export default SignInPage;